<template>
  <div class="error">
    <Nav only />
    <span>{{ message }}</span>
  </div>
</template>

<script>
import Nav from '../components/comm/Nav';
export default {
  components: {
    Nav,
  },
  data() {
    return {
      message: '404 page not found',
    };
  },
  mounted() {
    let { query } = this.$route;
    if (query.message) {
      this.message = query.message;
    }
  },
};
</script>

<style lang="less" scoped>
@import '../assets/fonts/font.less';
@import '../assets/css/main.less';
.error {
  .font-regular;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
}
</style>
